
let isDynamicLocation = document.querySelectorAll('.anchornav .ls-location-is-dynamic');
if (isDynamicLocation.length < 1) {

	let sections = document.querySelectorAll('.anchornav section section');

	let defaults = [
		'Services',
		'Website',
		'Localsearch.com.au',
		'SEO',
		'SEM',
		'Social Media Marketing',
		'Google Business Profile',
	]

	let d = 0;
	for (let i = 0; sections.length > i; i++) {
		// skip the section, not the default
		if (sections[i].querySelector('.elementor-button-link')) {

			if (sections[i].getAttribute('data-anchornav-section') === 'skip_default') {
				d++
				sections[i].setAttribute('data-anchornav-section', defaults[d])
			}

			// If it already has the attr, use it instead, and advace to next default
			if (sections[i].getAttribute('data-anchornav-section')) {
				d++; continue
			}

			sections[i].setAttribute('data-anchornav-section', defaults[d])
			d++
		}
	}
}
